// Import des styles communs + spécifiques au formulaire
import './styles/main.css';
import './styles/form-wizard.css';

// Import des images
import logoImg from './assets/images/logo.png';

// ============================================
// LOADER LOGIC (copié depuis index.js)
// ============================================
function initLoader() {
  const loader = document.getElementById('loader');
  const progress = document.getElementById('loaderProgress');
  const percentage = document.getElementById('loaderPercentage');

  if (!loader || !progress) return;

  let width = 0;
  const duration = 3000;
  const interval = 30;
  const increment = 100 / (duration / interval);

  const loadingInterval = setInterval(() => {
    width += increment;

    if (width >= 100) {
      width = 100;
      clearInterval(loadingInterval);

      setTimeout(() => {
        loader.classList.add('hidden');
      }, 500);
    }

    progress.style.width = width + '%';
    if (percentage) {
      percentage.textContent = Math.floor(width) + '%';
    }
  }, interval);
}

// ============================================
// MOBILE MENU LOGIC (copié depuis index.js)
// ============================================
function initMobileMenu() {
  const header = document.querySelector('.navbar');
  const burger = document.querySelector('.nav-burger');
  const menu = document.getElementById('navMenu');

  if (!header || !burger || !menu) return;

  function closeMenu() {
    header.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
  }

  function toggleMenu() {
    const isOpen = header.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', String(isOpen));
  }

  burger.addEventListener('click', toggleMenu);

  menu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMenu);
  });
}

// ============================================
// WIZARD FORM LOGIC (depuis votre form.html)
// ============================================
function initWizard() {
  let currentStep = 1;
  const totalSteps = 5;
  const formData = {};
  
  const eventTypeLabels = {
    'corporate': 'Corporate',
    'teambuilding': 'Team Building',
    'inauguration': 'Inauguration',
    'reception': 'Réception',
    'formation': 'Formation',
    'autre': 'Autre'
  };
  
  const guestsLabels = {
    '10-25': '10-25 personnes',
    '25-50': '25-50 personnes',
    '50-100': '50-100 personnes',
    '100-200': '100-200 personnes',
    '200+': '+ de 200 personnes'
  };
  
  const budgetLabels = {
    '500-1000': '500€ - 1 000€',
    '1000-2500': '1 000€ - 2 500€',
    '2500-5000': '2 500€ - 5 000€',
    '5000-10000': '5 000€ - 10 000€',
    '10000+': '10 000€ et plus'
  };
  
  function updateProgress() {
    const progress = (currentStep / totalSteps) * 100;
    document.getElementById('progressBar').style.width = progress + '%';
    
    document.querySelectorAll('.step-dot').forEach((dot, index) => {
      const stepNum = index + 1;
      dot.classList.remove('active', 'completed');
      if (stepNum < currentStep) {
        dot.classList.add('completed');
      } else if (stepNum === currentStep) {
        dot.classList.add('active');
      }
    });
  }
  
  function showStep(step) {
    document.querySelectorAll('.step-content').forEach(content => {
      content.classList.remove('active');
    });
    
    const currentContent = document.querySelector(`.step-content[data-step="${step}"]`);
    if (currentContent) {
      currentContent.classList.add('active');
    }
    
    const btnPrev = document.getElementById('btnPrev');
    const btnNext = document.getElementById('btnNext');
    const wizardNav = document.getElementById('wizardNav');
    
    if (step === 1) {
      btnPrev.style.visibility = 'hidden';
    } else {
      btnPrev.style.visibility = 'visible';
    }
    
    if (step === totalSteps) {
      btnNext.textContent = 'Envoyer ma demande ✓';
      btnNext.classList.remove('btn-next');
      btnNext.classList.add('btn-submit');
      updateRecap();
    } else {
      btnNext.textContent = 'Suivant →';
      btnNext.classList.remove('btn-submit');
      btnNext.classList.add('btn-next');
    }
    
    if (step === 6) {
      wizardNav.style.display = 'none';
    } else {
      wizardNav.style.display = 'flex';
    }
    
    updateProgress();
  }
  
  window.selectOption = function(element, inputName) {
    const parent = element.parentElement;
    parent.querySelectorAll('.option-card').forEach(card => {
      card.classList.remove('selected');
    });
    
    element.classList.add('selected');
    
    const input = document.getElementById(inputName);
    input.value = element.dataset.value;
    
    const errorEl = document.getElementById('error-step' + currentStep);
    if (errorEl) errorEl.style.display = 'none';
    
    formData[inputName] = element.dataset.value;
  };
  
  window.toggleCheckbox = function(label) {
    const checkbox = label.querySelector('input[type="checkbox"]');
    checkbox.checked = !checkbox.checked;
    
    if (checkbox.checked) {
      label.classList.add('checked');
    } else {
      label.classList.remove('checked');
    }
    
    updateServices();
  };
  
  function updateServices() {
    const checkboxes = document.querySelectorAll('input[name="services"]:checked');
    const services = Array.from(checkboxes).map(cb => cb.value);
    formData.services = services;
    
    if (services.length > 0) {
      document.getElementById('error-step4').style.display = 'none';
    }
  }
  window.updateServices = updateServices;
  
  function validateStep(step) {
    let isValid = true;
    
    if (step === 1) {
      if (!document.getElementById('eventType').value) {
        document.getElementById('error-step1').style.display = 'block';
        isValid = false;
      }
    }
    
    if (step === 2) {
      if (!document.getElementById('guests').value) {
        document.getElementById('error-step2').style.display = 'block';
        isValid = false;
      }
    }
    
    if (step === 3) {
      const date = document.getElementById('eventDate');
      const location = document.getElementById('eventLocation');
      
      if (!date.value) {
        date.parentElement.classList.add('has-error');
        isValid = false;
      } else {
        date.parentElement.classList.remove('has-error');
      }
      
      if (!location.value.trim()) {
        location.parentElement.classList.add('has-error');
        isValid = false;
      } else {
        location.parentElement.classList.remove('has-error');
      }
    }
    
    if (step === 4) {
      const services = document.querySelectorAll('input[name="services"]:checked');
      if (services.length === 0) {
        document.getElementById('error-step4').style.display = 'block';
        isValid = false;
      }
    }
    
    if (step === 5) {
      const email = document.getElementById('contactEmail');
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
      if (!email.value || !emailRegex.test(email.value)) {
        email.parentElement.classList.add('has-error');
        isValid = false;
      } else {
        email.parentElement.classList.remove('has-error');
      }
    }
    
    if (!isValid) {
      const content = document.querySelector(`.step-content[data-step="${step}"]`);
      content.classList.add('shake');
      setTimeout(() => content.classList.remove('shake'), 250);
    }
    
    return isValid;
  }
  
  function updateRecap() {
    document.getElementById('recap-eventType').textContent = eventTypeLabels[formData.eventType] || '-';
    document.getElementById('recap-guests').textContent = guestsLabels[formData.guests] || '-';
    
    const date = document.getElementById('eventDate').value;
    const time = document.getElementById('eventTime').value;
    let dateStr = '-';
    if (date) {
      const dateObj = new Date(date);
      dateStr = dateObj.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' });
      if (time) dateStr += ' à ' + time;
    }
    document.getElementById('recap-date').textContent = dateStr;
    
    document.getElementById('recap-location').textContent = document.getElementById('eventLocation').value || '-';
    
    const duration = document.getElementById('serviceDuration');
    document.getElementById('recap-duration').textContent = duration.options[duration.selectedIndex].text;
    
    const servicesContainer = document.getElementById('recap-services');
    servicesContainer.innerHTML = '';
    if (formData.services && formData.services.length > 0) {
      formData.services.forEach(service => {
        const tag = document.createElement('span');
        tag.className = 'service-tag';
        tag.textContent = service;
        servicesContainer.appendChild(tag);
      });
    } else {
      servicesContainer.textContent = '-';
    }
    
    const budget = document.getElementById('budget').value;
    if (budget) {
      document.getElementById('recap-budget').textContent = budgetLabels[budget];
      document.getElementById('recap-budget-row').style.display = 'flex';
    } else {
      document.getElementById('recap-budget-row').style.display = 'none';
    }
  }
  
  window.nextStep = function() {
    if (!validateStep(currentStep)) return;
    
    if (currentStep < totalSteps) {
      currentStep++;
      showStep(currentStep);
    } else {
      submitForm();
    }
  };
  
  window.prevStep = function() {
    if (currentStep > 1) {
      currentStep--;
      showStep(currentStep);
    }
  };
  
  function submitForm() {
    const finalData = {
      eventType: formData.eventType,
      guests: formData.guests,
      date: document.getElementById('eventDate').value,
      time: document.getElementById('eventTime').value,
      location: document.getElementById('eventLocation').value,
      duration: document.getElementById('serviceDuration').value,
      services: formData.services,
      budget: document.getElementById('budget').value,
      details: document.getElementById('eventDetails').value,
      email: document.getElementById('contactEmail').value,
      phone: document.getElementById('contactPhone').value,
      message: document.getElementById('finalMessage').value
    };
    
    console.log('Submit:', finalData);
    // fetch('/api/devis', { method: 'POST', body: JSON.stringify(finalData) })
    
    currentStep = 6;
    showStep(6);
  }
  
  // Init
  showStep(1);
  
  // Set min date
  const today = new Date().toISOString().split('T')[0];
  document.getElementById('eventDate').setAttribute('min', today);
}

// ============================================
// INITIALISATION
// ============================================
document.addEventListener('DOMContentLoaded', () => {
  initLoader();
  initMobileMenu();
  initWizard();
});